import React from 'react';
import '../styles/Editor.css';
import languages from '../data/languages.json';
import AceEditor from 'react-ace';
import ace from 'ace-builds';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-xml';
import 'ace-builds/src-noconflict/mode-css';
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/mode-sql';
import 'ace-builds/src-noconflict/mode-csharp';
import 'ace-builds/src-noconflict/mode-java';
import 'ace-builds/src-noconflict/mode-ruby';
import 'ace-builds/src-noconflict/mode-jsx';
import 'ace-builds/src-noconflict/mode-typescript';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/theme-monokai';

// Point ace workers/modes at the bundled copies so CRA's dev server
// doesn't 404 them with an HTML response.
ace.config.set('basePath', 'https://cdn.jsdelivr.net/npm/ace-builds@1.32.3/src-noconflict/');

const getMode = (language) => {
  try {
    const languageInfo = languages.languages.find((lang) => lang.name === language);
    if (languageInfo && languageInfo.mode) {
      require(`ace-builds/src-noconflict/mode-${languageInfo.mode}`);
      return languageInfo.mode;
    }
  } catch (error) {
    console.error(`Error setting mode for language ${language}:`, error);
  }
  return 'text';
};

const Editor = ({ onChange, language, content }) => {
  const options = {
    enableBasicAutocompletion: false,
    enableLiveAutocompletion: false,
    enableSnippets: false,
    showLineNumbers: true,
    tabSize: 2,
    mode: getMode(language),
    theme: 'github',
  };

  return (
    <div className="Editor" style={{ height: '450px', overflow: 'auto' }}>
      <AceEditor
        value={content || ''}
        onChange={onChange}
        width="100%"
        height="100%"
        fontSize={16}
        editorProps={{ $blockScrolling: true }}
        setOptions={{ useWorker: false }}
        {...options}
      />
    </div>
  );
};

export default Editor;
